var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-tasks-wrapper",
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-tasks-list",
        },
        [
          _vm.userIsTeacher
            ? _c("CoursewareDashboardStudents")
            : _c("CoursewareDashboardTasks"),
        ],
        1
      ),
      _vm._v(" "),
      _vm.userIsTeacher
        ? _c(
            "MountingPortal",
            {
              attrs: {
                mountTo: "#courseware-action-widget",
                name: "sidebar-actions",
              },
            },
            [_c("CoursewareTasksActionWidget")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("courseware-companion-overlay"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }